var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.embedUrl)?_c('iframe',{attrs:{"src":_vm.embedUrl,"width":"100%","height":"100%"}}):(_vm.errorMsg != null)?_c('div',[_c('div',{staticClass:"alert alert-danger show mt-2",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errorMsg))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }